// Client lib imports
const businessEvents = require('client/lib/business-events')
const { send: ajax } = require('client/lib/request')

const API = {
  createMix: async function (name, isRecommended = false, pageContext = {}) {
    const response = await ajax({
      url: '/api/v0.1/mixes',
      method: 'post',
      data: {
        name: name.trim(),
        description: '',
        recommended: isRecommended,
        'page_context': pageContext
      }
    })
    await businessEvents.trackSegment('create-mix', {
      name: response.name,
      'mix_id': response.id
    }, {
      pageContext
    })
    return response
  },

  addToMix: async function (mixId, urlId, pageContext = {}) {
    const response = await ajax({
      url: `/api/v0.1/mix/url/${mixId}`,
      method: 'post',
      data: {
        'url_id': urlId,
        'page_context': pageContext
      }
    })
    await businessEvents.trackSegment('add-url-to-mix', {
      mixId: mixId, // QUESTION: Shouldn't this be 'mix_id'?
      'url_id': urlId
    }, {
      pageContext
    })
    return response
  },

  removeFromMix: async function (mixId, urlId, pageContext = {}) {
    const response = await ajax({
      url: `/api/v0.1/mix/url/${mixId}`,
      method: 'delete',
      data: {
        'url_id': urlId,
        'page_context': pageContext
      }
    })
    await businessEvents.trackSegment('remove-url-from-mix', {
      mixId: mixId, // QUESTION: Shouldn't this be 'mix_id'?
      'url_id': urlId
    }, {
      pageContext
    })
    return response
  }
}

module.exports = { API }
